// mutations
const INVENTORY_PROVIDERS_ALL = (state, inventoryProviders) => {
  if (inventoryProviders.code === 1) {
    state.inventoryProviders = inventoryProviders.data
    state.status = 'success'
  } else {
    alert(inventoryProviders.message)
    state.status = 'error'
  }
}

const INVENTORY_PROVIDERS_FORM = (state, inventoryProviders) => {
  if (inventoryProviders.code === 1) {
    state.inventoryProviders = inventoryProviders.data
    state.status = 'success'
  } else {
    alert(inventoryProviders.message)
    state.status = 'error'
  }
}

const INVENTORY_PROVIDERS_SHOW = (state, inventoryProviders) => {
  if (inventoryProviders.code === 1) {
    state.inventoryProviders = inventoryProviders.data
    state.status = 'success'
  } else {
    alert(inventoryProviders.message)
    state.status = 'error'
  }
}

const INVENTORY_PROVIDERS_CREATE = (state, inventoryProviders) => {
  if (inventoryProviders.code === 1) {
    state.inventoryProviders = inventoryProviders.data
    state.status = 'success'
    alert(inventoryProviders.message)
  } else {
    alert(inventoryProviders.message)
    state.status = 'error'
  }
}

const INVENTORY_PROVIDERS_UPDATE = (state, inventoryProviders) => {
  if (inventoryProviders.code === 1) {
    state.inventoryProviders = inventoryProviders.data
    state.status = 'success'
    alert(inventoryProviders.message)
  } else {
    alert(inventoryProviders.message)
    state.status = 'error'
  }
}

const INVENTORY_PROVIDERS_DELETE = (state, inventoryProviders) => {
  if (inventoryProviders.code === 1) {
    state.inventoryProviders = inventoryProviders.data
    state.status = 'success'
    alert(inventoryProviders.message)
  } else {
    alert(inventoryProviders.message)
    state.status = 'error'
  }
}

export default {
  INVENTORY_PROVIDERS_ALL,
  INVENTORY_PROVIDERS_FORM,
  INVENTORY_PROVIDERS_SHOW,
  INVENTORY_PROVIDERS_CREATE,
  INVENTORY_PROVIDERS_UPDATE,
  INVENTORY_PROVIDERS_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/providers/mutations.js